import Helpers from './Helpers.js'
import LoggedInUser from './LoggedInUser.js'

class Job {
  constructor(params){
    Object.keys(params).forEach(function(attr){
      this[attr] = params[attr];
    }.bind(this));
  }

  image(size=400){
    let image = null;
    if (this.project.images && this.project.images.length > 0) {
      image = Helpers.imageURL(this.project.images[0], size)
    }
    return (image || Helpers.defaultThumbnail);
  }

  bookingString(){
    console.log(this.booking)
    if(this.booking){return 'Yes'}
    return 'No'
  }

  datePosted(){
    return new Date(Date.parse(this.created_at)).toISOString().slice(0,10);
  }

  datesString(){
    return this.dates.map(function(date){
      return date.slice(0,10)
    }).join(", ")
  }

  panelColor(){
    if (!this.hidden){
      return 'info'
    }
  }

  totalRate(){
    if(this.hours){return this.rate * this.hours }
    return this.rate * this.days
  }

  approvedBy() {
    if (this.ledger && this.ledger.find(ledgerItem => (ledgerItem.action === 'adminApprovedJob' && ledgerItem.metadata))) {
      const ledgerItem = this.ledger.find(ledgerItem => (ledgerItem.action === 'adminApprovedJob'));
      return ledgerItem.metadata.approved_by;
    }
    return 'N/A';
  }

  viewInfoURL(){
    return Helpers.backendURL+'/job_info/'+this.swipecast_job_id+'?auth_token='+LoggedInUser.getInfo().auth_token
  }

  awaitingThirdParty(){
    return ['jobWaitingForThirdPartyPayAndTalentAccept', 'jobWaitingForThirdPartyPay'].filter((status)=>{return this.status == status}).length > 0
  }

  update(params){
    return fetch(Helpers.endpoint("/update_job"), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        Object.assign(
          {},
          {
            auth_token: LoggedInUser.getInfo().auth_token,
            job: params,
            swipecast_job_id: this.swipecast_job_id
          }
        )
      )
    })
  }

  approve(manual_ordering, editorial_tier, commercial_tier){
    return fetch(Helpers.endpoint("/approve_jobs"), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        auth_token: LoggedInUser.getInfo().auth_token,
        swipecast_job_ids: [this.swipecast_job_id],
        manual_ordering: manual_ordering,
        commercial_tier: commercial_tier,
        editorial_tier: editorial_tier,
        tags: ['sc_ranked']
      })
    })
  }

  unexpire(days){
    return fetch(Helpers.endpoint("/unexpire_job"), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        auth_token: LoggedInUser.getInfo().auth_token,
        swipecast_job_id: this.swipecast_job_id,
        days: days
      })
    })
  }

  markAsCanceled(){
    return fetch(Helpers.endpoint("/mark_job_as_canceled"), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        auth_token: LoggedInUser.getInfo().auth_token,
        swipecast_job_id: this.swipecast_job_id
      })
    })
  }

  markAsCompleted(){
    return fetch(Helpers.endpoint("/mark_job_as_completed"), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        auth_token: LoggedInUser.getInfo().auth_token,
        swipecast_job_id: this.swipecast_job_id
      })
    })
  }

  notify(lat, lng, radius){
    return fetch(Helpers.endpoint("/notify_potential_applicants_of_job"), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        auth_token: LoggedInUser.getInfo().auth_token,
        swipecast_job_id: this.swipecast_job_id,
        lat: lat,
        lng: lng,
        radius: radius
      })
    })
  }

  hide(){
    return fetch(Helpers.endpoint("/update_job"), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        auth_token: LoggedInUser.getInfo().auth_token,
        swipecast_job_id: this.swipecast_job_id,
        job: {
          hidden: true
        }
      })
    })
  }
}

export default Job;
